// extracted by mini-css-extract-plugin
export default {"labelContainer":"Label_labelContainer__+SrZs"};